import { useCallback } from 'react';

import Intercom from '@intercom/messenger-js-sdk';

import { useAuthStore } from '@/stores/userStore';

export const useIntercom = () => {
  const accountId = useAuthStore((state) => { return state.account?.id; });
  const topupId = useAuthStore((state) => { return state.account?.topup_id; });
  const accountName = useAuthStore((state) => { return state.account?.name; });
  const accountEmail = useAuthStore((state) => { return state.account?.email; });
  const accountCreatedAt = useAuthStore((state) => { return state.account?.createdAt; });

  const initializeIntercom = useCallback(async () => {
    try {
      if (typeof window === 'undefined') {
        return;
      }

      let config;
      if (accountId && topupId) {
        const hash = await fetch('/api/integrations/intercom').then((res) => { return res.json(); });
        config = {
          app_id: 'l2erqbk4',
          user_id: topupId,
          name: accountName,
          email: accountEmail,
          company: 'Powerbet',
          created_at: accountCreatedAt ? Math.floor(new Date(accountCreatedAt).getTime() / 1000) : undefined,
          user_hash: hash,
          hide_default_launcher: true,
        };
      } else {
        config = {
          app_id: 'l2erqbk4',
          company: 'Powerbet',
          hide_default_launcher: true,
        };
      }

      if (window.Intercom) {
        try {
          window.Intercom('update', config);
        } catch {
          Intercom(config);
        }
      } else {
        Intercom(config);
      }
    } catch (error) {
      console.warn('Error initializing Intercom:', error);
    }
  }, [accountId, topupId, accountName, accountEmail, accountCreatedAt]);

  const showIntercom = useCallback(() => {
    if (typeof window !== 'undefined' && window.Intercom) {
      window.Intercom('show');
    }
  }, []);

  const handleSupportClick = useCallback(async () => {
    await initializeIntercom();
    showIntercom();
  }, [initializeIntercom, showIntercom]);

  return {
    initializeIntercom,
    showIntercom,
    handleSupportClick,
  };
};
